'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDisplayName;
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-typeahead/lib/utils/getDisplayName.js
// module id = 163
// module chunks = 0